<mat-card-content class="d-flex">
    <mat-form-field class="col-9">
        <mat-label>File Name</mat-label>
        <input matInput type="text" placeholder="Ex. My-Data-Export" [(ngModel)]="fileName" (keyup.enter)="export()">

    </mat-form-field>
    <div class="col-3">
    <button id="exportButton" mat-raised-button (click)="export()" [color]="'primary'" >Export</button>
    <button mat-raised-button mat-dialog-close>Cancel</button>
    </div>
</mat-card-content>
